import React, { Component } from "react";
import styles from "@src/components/import/addImport.module.less";
import DetailList from "./importDetailList.tsx";
import { v4 as uuid } from "uuid";

import { ProgressInfo } from "../progress";
import reactRender from "@src/utils/reactRender";
import * as services from "@api";
import { isType } from "@src/utils";
import { ImportType } from "@src/actions/bill";

import { utils } from "ynf-core-middleware";
const { formatUtils } = utils;

const TinperNext = window.TinperNext || {};
const { Upload, Button, Icon, Progress, Table } = TinperNext;

let num = 0;
const POLLING_INTERVAL = 2000;
export default class ImportCom extends Component {
  // 服务编码
  serviceCode = "";
  // 记录导入时间
  startTime = "";
  // 导入进度球实例
  progressInstance: any;
  state = {
    errorDetailVisible: false,
    uploadAlias: uuid(),
    asyncKey: "",
    errorDetail: "",
    successDetail: "",
    fileList: [],
    progressNow: 0,
    uploadFileMsg: "", // 上传失败文案
    isProcessFinished: false, // 是否上传完成
    isShowUploadProgress: false, // 上传进度
    timer: null,
    uploadInterrupt: false, // 上传中断
    errorInfo: {}, // 后端返回的映射关系,错误信息等
    percentage: 0,
    totalCount: 0,
    successCount: 0,
    errorCount: 0,
    failInfos: [],
    errorStats: []
  };

  columns = [
    {
      title: lang.templateByUuid('UID:P_CORE-YNF-FE_18951C6005B80023', '序号'),
      dataIndex: "index",
      key: "index",
      width: 80,
      render(_text: any, _record: any, index: number) {
        return index + 1;
      }
    },
    { title: lang.templateByUuid('UID:P_CORE-YNF-FE_18951C6005B80028', '页签'), dataIndex: "sheetName", key: "sheetName", width: 100 },
    { title: lang.templateByUuid('UID:P_CORE-YNF-FE_18951C6005B8002A', '字段'), dataIndex: "columnName", key: "columnName", width: 100 },
    { title: lang.templateByUuid('UID:P_CORE-YNF-FE_18951C6005B8002B', '失败行号'), dataIndex: "row", key: "row", width: 100 },
    {
      title: lang.templateByUuid('UID:P_CORE-YNF-FE_18951C6005B8002C', '失败原因'),
      dataIndex: "errorMessage",
      key: "errorMessage",
      width: 300
    }
  ];

  componentDidMount(): void {
    this.serviceCode =
      this.props.rootStore.pageStore.params?.serviceCode || "bank_u8c";
    this.getResourse();
  }

  getResourse = () => {
    // 协同js在加载中
    if (window.uploadFileLoading) {
      // 开启定时器
      const timer = setInterval(() => {
        // 如果uploadFileRef没了，说明组件重新挂载了，立即结束定时器，没必要继续执行了
        if (!this.uploadFileRef) {
          clearInterval(timer);
          return;
        }
        // 如果js加载完毕，清除定时器，并执行init
        if (!window.uploadFileLoading) {
          clearInterval(timer);
        }
      }, 100);
    } else {
      // 组件第一次挂载，加载标记设置成true
      window.uploadFileLoading = true;
      utils
        .loadScript([
          `${window.__MAIN_ORIGIN__}/iuap-apcom-file/ucf-wh/fileservice/web/fileservice-web.min.js`
        ])
        .then((res) => {
          let flag = false;
          window.YYCooperationBridge?.ready?.(() => {
            flag = true;
            // 加载成功，标记设置为false
            window.uploadFileLoading = false;
          });
          return flag;
        });
    }
  };

  // 重置进度条
  resetProgress = (payload = {}) => {
    const {
      errorStats = [],
      progressNow = 0,
      uploadFileMsg = "",
      isProcessFinished = false,
      isShowUploadProgress,
      timer
    } = payload;

    this.setState({
      errorStats,
      progressNow,
      uploadFileMsg,
      isProcessFinished,
      isShowUploadProgress: !!isShowUploadProgress,
      timer,
      uploadInterrupt: false
    });
  };

  // 处理进度条动画
  handleProgressBar = () => {
    const { progressNow, isShowUploadProgress } = this.state;
    return isShowUploadProgress
      ? (
        <div className={styles["yb_import_progress_box"]}>
          <span>{lang.templateByUuid('UID:P_CORE-YNF-FE_18951C6005B80016', '上传文件并解析中，请稍后')}</span>
          <div className={styles["yb_import_progress"]}>
            <Progress
              percent={progressNow}
              status="active"
              strokeColor={{ from: "#38c6ff", to: "#5f8ef9" }}
              strokeWidth={5}
            />
          </div>
        </div>
      )
      : null;
  };

  // 渲染导入弹窗内容
  renderChildren = () => {
    const {
      fileList,
      isProcessFinished,
      isShowUploadProgress,
      uploadFileMsg,
      errorStats
    } = this.state;
    const isActionOver = isProcessFinished && !isShowUploadProgress; // 点击了上传，并且上传已结束
    const isNoError = isActionOver && !uploadFileMsg && !errorStats?.length; // errorStatisticsKey为后端返回的
    const props = {
      name: "file",
      action: "",
      showUploadList: false,
      fileList,
      accept: ".xlsx,.xls,.zip", // 默认接受文件类型
      beforeUpload: this.handleBeforeUpload.bind(this),
      customRequest: this.doImgUpload
    };
    return (
      <div>
        <div className={styles["yb_import_title"]}>{lang.templateByUuid('UID:P_CORE-YNF-FE_18951C6005B80020', '上传文件')}</div>
        <Upload {...props}>
          <Button shape="border">
            <Icon type="uf-upload" /> {lang.templateByUuid('UID:P_CORE-YNF-FE_18951C6005B80021', '点击上传')}
          </Button>
          <span className={styles["yb_import_tip"]}>
            {lang.templateByUuid('UID:P_CORE-YNF-FE_18951C6005B80022', '当前仅支持excel格式文件（文件大小在500MB以内）')}
          </span>
        </Upload>
        {fileList.length > 0 && (
          <div className={styles["yb_import_list"]}>
            {fileList.map((item) => {
              return (
                <div className={styles["yb_import_item_box"]} key={item.id}>
                  <span
                    className={styles["yb_import_filename"]}
                    title={item.name}
                  >
                    {item.name}
                  </span>
                  <div className={styles["yb_import_file_right"]}>
                    {/* 上传进度 */}
                    {!isActionOver && this.handleProgressBar()}

                    {isActionOver && uploadFileMsg
                      ? (
                        <span className={styles["yb_import_file_status"]}>
                          {lang.templateByUuid('UID:P_CORE-YNF-FE_18951C6005B80015', '上传失败')}
                        </span>
                      )
                      : null}

                    {isActionOver && !uploadFileMsg
                      ? (
                        <span className={styles["yb_import_success_status"]}>
                          {lang.templateByUuid('UID:P_CORE-YNF-FE_18951C6005B80017', '上传完成')}
                        </span>
                      )
                      : null}

                    <span
                      className={styles["yb_import_close"]}
                      onClick={this.handleAbort}
                    >
                      X
                    </span>
                  </div>
                </div>
              );
            })}
          </div>
        )}

        {fileList.length > 0 && (
          <div className={styles["yb_import_bottom"]}>
            {uploadFileMsg
              ? (
                <div
                  className={styles["yb_import_failmsg"]}
                >{`${lang.templateByUuid('UID:P_CORE-YNF-FE_18951C6005B8001A', '失败原因：')}${uploadFileMsg}`}</div>
              )
              : null}
            {isNoError
              ? (
                <div
                  className={styles["yb_import_successmsg"]}
                  dangerouslySetInnerHTML={{
                    __html: `<span class=${styles["yb_import_filename"]}>${fileList[0]?.name}${lang.templateByUuid('UID:P_CORE-YNF-FE_18951C6005B8001F', '</span>无异常数据，可进行导入')}`
                  }}
                ></div>
              )
              : null}

            {/* 经初步数据校验，<%=name%>无异常数据，可进行导入 */}
            {/* 展示异常数据 */}
            {errorStats?.length > 0 && this.errdetailChildren(errorStats)}
          </div>
        )}
      </div>
    );
  };

  getDisabledStatus = () => {
    const {
      fileList,
      isProcessFinished,
      isShowUploadProgress,
      uploadFileMsg,
      errorStats
    } = this.state;
    const isActionOver = isProcessFinished && !isShowUploadProgress; // 点击了上传，并且上传已结束
    const isNoError = isActionOver && !uploadFileMsg && !errorStats?.length; // errorStatisticsKey为后端返回的
    return {
      disabled: !(fileList.length > 0 && isNoError)
    };
  };

  // 取消上传
  handleAbort = async() => {
    // 取消后端校验轮询
    const { timer } = this.state;
    if (timer) clearInterval(timer);
    this.resetProgress({ timer });
    this.setState({ fileList: [] });
  };

  // 上传前事件
  handleBeforeUpload = async(file) => {
    this.resetProgress({
      isShowUploadProgress: true
    });
    // 只加载最新上传的文件
    const fileList = [file];
    this.setState({ fileList });
  };

  // 自定义上传: 上传到协同服务获取服务ID
  doImgUpload = (v1: any) => {
    const { pageStore = {} } = this.props.rootStore;
    window.YYCooperationBridge.YYUploadFiles({
      files: [v1.file] || [],
      authId: this.serviceCode,
      appCode: "iuap-metadata-import" || pageStore.params?.ownDomain,
      businessId: uuid(), // 这里不使用详情页的billNo，为了避免协作套件上展示出来
      beforeUpload: (_file: any) => {},
      onFailed: (error: any) => {
        console.log("come in onFailed--", error);
        this.setState({
          uploadFileMsg: error?.message || lang.templateByUuid('UID:P_CORE-YNF-FE_18951C6005B8001B', '本地上传文件失败'),
          isShowUploadProgress: false,
          isActionOver: true
        });
      },
      onSuccess: (file: any) => {
        console.log("onSuccess-file----", file);
        this.doUploadAction({
          fileId: file.id,
          fileName: file.file.name,
          importStatus: 1,
          objectId: pageStore.params?.billNo,
          objectName: "u8c" || pageStore.params?.ownDomain
        });
      }
    });
  };

  // 拿到服务ID，传给对应的领域服务
  doUploadAction = async(params) => {
    const { pageStore = {} } = this.props.rootStore;
    const asyncKey = `asyncImport_${uuid().replace(/-/g, "")}`;
    this.setState({ asyncKey });
    const requestData = {
      params: {
        currentDomainKey: pageStore.params?.domainKey,
        terminalType: pageStore.query?.terminalType,
        busiObj: pageStore.params?.busiObj,
        asyncKey,
        billnum: this.props.detailBillNo
      },
      data: {
        ...params
      }
    };
    // 如果是更新导入的时候，增加参数
    if (this.props.type === ImportType.updateImport) {
      requestData.data.importMode = 2
    }
    const res = await services.billImport(requestData);
    if (res.code === 200) {
      setTimeout(async() => {
        this.checkProcess(res.data.infos[0]);
      }, 2000);
    } else {
      // res.errorDetail
      this.setState({ errorDetail: res.errorDetail });
    }
  };

  // 检查进度
  checkProcess = async({ asyncKey, url }) => {
    const { pageStore = {}, utils } = this.props.rootStore;
    try {
      const requestData = {
        params: {
          currentDomainKey: pageStore.params?.domainKey,
          terminalType: pageStore.query?.terminalType,
          busiObj: pageStore.params?.busiObj,
          asyncKey
        },
        controller: url
      };
      const res = await services.checkProcess(requestData);
      if (res.code === 200) {
        num = 0;
        this.setState({ progressNow: res.data.percentage });
        if (Number(res.data.percentage) === 100) {
          this.setState({
            uploadFileMsg: "",
            progressNow: 100,
            isProcessFinished: true,
            isShowUploadProgress: false
          });
        } else {
          const self = this;
          setTimeout(() => self.checkProcess({ asyncKey, url }), 2000);
        }
      } else {
        const errorStats = res?.data?.errorStats || [];
        if (errorStats.length > 0) {
          this.setState({
            errorCount: res?.data?.errorCount || 0,
            errorStats,
            isProcessFinished: true,
            isShowUploadProgress: false
          });
        } else {
          // 连续三次请求报错后，再抛出错误信息
          num = num + 1;
          if (num >= 3) {
            this.setState({
              uploadFileMsg: res?.message || "",
              errorStats,
              errorCount: res?.data?.errorCount || 0,
              isProcessFinished: true,
              isShowUploadProgress: false
            });
          } else {
            const self = this;
            setTimeout(() => self.checkProcess({ asyncKey, url }), 2000);
          }
        }
      }
    } catch (res: any) {
      if (res.code === 999) {
        this.setState({
          uploadFileMsg: res?.message || "",
          errorStats: res?.data?.errorStats,
          errorCount: res?.data?.errorCount || 0,
          isProcessFinished: true,
          isShowUploadProgress: false
        });
      } else {
        utils.message.danger(e.message || lang.templateByUuid('UID:P_CORE-YNF-FE_18951C6005B80018', '检查进度失败'));
      }
    }
  };

  // 导入触发
  importAction = async() => {
    this.startTime = formatUtils.formatDate(new Date(), "yyyy-MM-dd hh:mm:ss");
    const { pageStore, utils } = this.props.rootStore;
    const { asyncKey, isProcessFinished, uploadFileMsg } = this.state;
    if (!asyncKey || !isProcessFinished || uploadFileMsg) {
      return utils.message.danger(lang.templateByUuid('UID:P_CORE-YNF-FE_18951C6005B80019', '请先选择正确文件上传再导入'));
    }
    let requestData = {
      params: {
        currentDomainKey: pageStore.params?.domainKey,
        terminalType: pageStore.query?.terminalType,
        busiObj: pageStore.params?.busiObj
        // designPreview: true
      },
      data: {
        asyncKey,
        billNo: pageStore.params?.detailBillNo || pageStore.params?.billNo,
        currentDomainKey: pageStore.params?.domainKey
      }
    };
    // 导入动作 前置钩子
    if (isType(this.props.beforeNewAddImportHook, 'Function')) {
      requestData = await this.props.beforeNewAddImportHook(this.props.rootStore, requestData);
    }
    const res = await services.dispatchImportTask(requestData);
    if (res.code === 200) {
      // 导入动作 后置钩子
      if (isType(this.props.afterNewAddImportHook, 'Function')) {
        await this.props.afterNewAddImportHook(this.props.rootStore, res);
      }
      pageStore.closeModal({ uiType: "component" });
      utils.message.success(lang.templateByUuid('UID:P_CORE-YNF-FE_18951C6005B80029', '导入任务已转入后台，可进行其他操作'));
      this.importFile(res.data.infos[0]);
      // 初始化 progress实例
      this.progressInstance = reactRender(
        ProgressInfo,
        { percentage: 0 },
        () => document.querySelector(".yb-async-float-progress")?.parentNode
      );
    } else {
      this.setState({ errorDetail: res.message });
    }
  };

  // toDrew = async({ asyncKey, url }) => {
  //   try {
  //     const { pageStore } = this.props.rootStore;
  //     const requestData = {
  //       params: {
  //         currentDomainKey: pageStore.params?.domainKey,
  //         terminalType: pageStore.query?.terminalType,
  //         busiObj: pageStore.params?.busiObj,
  //         asyncKey
  //       },
  //       controller: url
  //     };
  //     return await services.toDrew(requestData);
  //   } catch (error) {
  //     return error
  //   }
  // };

  // 执行导入轮询
  importFile = async({ asyncKey, url }) => {
    const { pageStore, target, utils } = this.props.rootStore;
    let batchResolve: any;
    const batchPromise = new Promise((resolve) => {
      batchResolve = resolve;
    });
    const polling = () => {
      setTimeout(async() => {
        try {
          const { pageStore } = this.props.rootStore;
          const requestData = {
            params: {
              currentDomainKey: pageStore.params?.domainKey,
              terminalType: pageStore.query?.terminalType,
              busiObj: pageStore.params?.busiObj,
              asyncKey
            },
            controller: url
          };
          const res = await await services.toDrew(requestData);
          const percentage = Number(res.data?.percentage);
          if (!isNaN(percentage)) {
            this.progressInstance.update({ percentage });
            if (percentage === 100) {
              utils.notice.success({
                message: lang.templateByUuid('UID:P_CORE-YNF-FE_18951C6005B8001D', '导入成功'),
                description: lang.localeUuid('UID:P_CORE-YNF-FE_1895332E05B80001', { time: this.startTime })// 您于<%=time%>发起的导入已经完成。
              });
              this.progressInstance.destroy();
              // TODO 返回数据 批量处理小球逻辑

              // 导入成功刷新逻辑
              try {
                // 执行查询方法,参数从action 动作中传过来，需要配置，是哪个查询区store，才可以刷新
                this.props.rootStore[
                  this.props.filterStoreKey || "filterStore"
                ]?.setQueryTrigger();
              } catch (e) {
                console.log(e);
              }
              // if (res.data) {
              //   res.data.successCount = res.data?.successCount || 0;
              //   res.data.failCount = res.data?.errorCount || 0;
              //   res.data.failInfos = res.data?.errors || [];
              //   res.data.message = res.data?.message || [];
              //   res.data.actionType = "导入";
              //   res.data.cBillName = pageStore.params?.billName;
              //   res.data.afterOkClick = () => {
              //     this.setState({
              //       errorDetailVisible: true,
              //       totalCount: res.data?.totalCount,
              //       successCount: res.data?.sucessCount || 0,
              //       errorCount: res.data?.errorCount || 0,
              //       failInfos: res.data?.errors || [],
              //     });
              //   };
              // }
              return batchResolve();
            }
          }
          polling();
        } catch (error: any) {
          // 失败的时候给出提示
          const errors = error.data?.errors[0]
          this.progressInstance.destroy();
          // utils.notice.danger({
          //   message: lang.templateByUuid('UID:P_CORE-YNF-FE_18951C6005B80015', '上传失败'),
          //   description: `${lang.templateByUuid('UID:P_CORE-YNF-FE_18951C6005B8001A', '失败原因：')}${errors.sheetName}${','}${lang.templateByUuid('UID:P_CORE-YNF-FE_18951C6005B8002B', '失败行号')}${':'}${errors.row}`
          // });
          utils.message.danger(`${lang.templateByUuid('UID:P_CORE-YNF-FE_18951C6005B80015', '上传失败')}${': '}${errors.errorMessage}`)
        }
      }, POLLING_INTERVAL);
    };
    polling();
    await batchPromise;
  };

  errdetailChildren = (errorStats: any[]) => {
    const { fileList, errorCount } = this.state;
    return (
      <div className={styles["yb_import_content"]}>
        <div className={styles["yb_import_top"]}>
          {/* 经初步数据校验，<%=name%>存在<%=count%>处异常，明细如下： */}
          <div
            className={styles["yb_import_title"]}
            dangerouslySetInnerHTML={{
              __html: lang.localeUuid('UID:P_CORE-YNF-FE_189538E404500000', { name: `<span class=${"yb_import_filename"}>${
                fileList[0]?.name
              }</span>`, count: `<span class=${"yb_import_error_text"}>${
                errorCount || 0
              }</span>` })
            }}
          ></div>
          {/* <Button fieldid={`${this.getFieldId()}`} onClick={this.handleExport} model={this.vm} >
              导出异常原因
            </Button> */}
        </div>
        <div className={styles["yb_import_abnormal"]}>
          <DetailList errorStats={errorStats}></DetailList>
          {/* <Table fieldid={`${this.getFieldId()}`} noViewModel model={this.gridModel} width={900} autoHeight={false} height={190} /> */}
        </div>
      </div>
    );
  };

  errdetailResult = () => {
    const { pageStore } = this.props.rootStore;
    const {
      totalCount = 0,
      successCount = 0,
      errorCount = 0,
      failInfos = []
    } = this.state;
    return (
      <div className={styles["yb_import_content"]}>
        <div className={styles["yb_import_top"]}>
          <div
            className={styles["yb_import_title"]}
            dangerouslySetInnerHTML={{
              __html: `${lang.localeUuid('UID:P_CORE-YNF-FE_18B4AA0205080005', { totalCount, successCount, errorCount })}`
            }}
          ></div>
          {/* <Button fieldid={`${this.getFieldId()}`} onClick={this.handleExport} model={this.vm} >
              导出异常原因
            </Button> */}
        </div>
        <div className={styles["yb_import_abnormal"]}>
          <Table
            className={styles["child-table"]}
            columns={this.columns}
            data={failInfos}
          />
          {/* <Table fieldid={`${this.getFieldId()}`} noViewModel model={this.gridModel} width={900} autoHeight={false} height={190} /> */}
        </div>
      </div>
    );
  };

  cancel = () => {
    this.props.rootStore.pageStore.closeModal({ uiType: "component" });
  };

  getFieldId = () => {
    const { pageStore = {} } = this.props.rootStore
    // const { fieldid, fieldidPrefix } = this.props || {};
    return `${pageStore.params?.billNo}|${ImportType[this.props.type]}|btn`
  };

  render() {
    const { errorDetailVisible } = this.state;
    return (
      <>
        <div className={styles["yb_import"]}>
          {this.renderChildren()}
          {errorDetailVisible && this.errdetailResult()}
        </div>
        <div className={styles["yb_import_footer"]}>
          <Button
            onClick={this.cancel}
            colors="secondary"
            style={{ marginRight: 8 }}
          >
            {lang.templateByUuid('UID:P_CORE-YNF-FE_18951C6005B8001C', '取消')}
          </Button>
          <Button onClick={this.importAction} colors="primary">
            {lang.templateByUuid('UID:P_CORE-YNF-FE_18951C6005B8001E', '导入')}
          </Button>
        </div>
      </>
    );
  }
}
